module.exports = __webpack_public_path__ + "static/media/whiteradish.6f711c36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/whiteradish.jpg
// module id = 140
// module chunks = 0